import { Component, inject, input } from '@angular/core';
import { PanelModule } from 'primeng/panel';
import { Permissions } from '../../../../constants/permissions';
import {
  IEnergyMeterList,
  IEnergyMeterLog,
} from '../../../../models/energy-meter';
import { Auth } from '../../../../services/auth';
import { GraphView } from './graph-view/graph-view';
import { KnobView } from './knob-view/knob-view';

@Component({
  selector: 'app-energy-meter-view',
  imports: [KnobView, GraphView, PanelModule],
  templateUrl: './energy-meter-view.html',
  styleUrl: './energy-meter-view.css',
})
export class EnergyMeterView {
  readonly authService = inject(Auth);
  readonly permissions = Permissions;

  hasPermission(permission: Permissions): boolean {
    return this.authService.hasPermission(permission);
  }

  energyMeterList = input.required<IEnergyMeterList[]>();
  energyMeterLogInfo = input.required<IEnergyMeterLog[]>();
}
